import { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';
import { COLORS, CHART_CONFIG } from '@/constants/calculator';

const AXIS_TICK = { fill: COLORS.CHART_TICK };

const formatTooltipValue = (value) => [
  `$${typeof value === 'number' ? value.toFixed(2) : value}`,
  '',
];

const formatLabelValue = (v) => `$${v}`;
const formatLabelValueIfPositive = (v) => (v > 0 ? `$${v}` : '');

export const ComparisonChart = ({
  managedCost,
  selfDeliveryRate,
  holidayAmount,
  supervisorCost,
  nonProductiveAmount,
  nonEssentialAmount,
}) => {
  const chartData = useMemo(
    () => [
      {
        name: 'Managed Installation',
        'Managed Cost': managedCost,
      },
      {
        name: 'Self Delivery',
        'Base Rate': selfDeliveryRate,
        'Holiday/Sick/ACC/KS': holidayAmount,
        Supervisor: supervisorCost,
        'Non-Productive': nonProductiveAmount,
        'Non-Essential': nonEssentialAmount,
      },
    ],
    [managedCost, selfDeliveryRate, holidayAmount, supervisorCost, nonProductiveAmount, nonEssentialAmount]
  );

  return (
    <div className="bg-white border border-slate-200 p-8">
      <label className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500 block mb-6">
        VISUAL COMPARISON
      </label>

      <ResponsiveContainer width="100%" height={CHART_CONFIG.HEIGHT}>
        <BarChart data={chartData} margin={CHART_CONFIG.MARGIN}>
          <CartesianGrid strokeDasharray={CHART_CONFIG.GRID_DASH} stroke={COLORS.CHART_GRID} />
          <XAxis dataKey="name" tick={AXIS_TICK} />
          <YAxis tick={AXIS_TICK} />
          <Tooltip contentStyle={CHART_CONFIG.TOOLTIP_STYLE} formatter={formatTooltipValue} />
          <Bar dataKey="Managed Cost" stackId="a" fill={COLORS.PURPLE} radius={CHART_CONFIG.ZERO_RADIUS}>
            <LabelList
              dataKey="Managed Cost"
              position="center"
              fill="#ffffff"
              fontSize={CHART_CONFIG.LABEL_FONT_SIZE}
              fontWeight={CHART_CONFIG.LABEL_FONT_WEIGHT}
              formatter={formatLabelValue}
            />
          </Bar>
          <Bar dataKey="Base Rate" stackId="b" fill={COLORS.ORANGE} radius={CHART_CONFIG.ZERO_RADIUS}>
            <LabelList
              dataKey="Base Rate"
              position="center"
              fill="#ffffff"
              fontSize={CHART_CONFIG.LABEL_FONT_SIZE}
              fontWeight={CHART_CONFIG.LABEL_FONT_WEIGHT}
              formatter={formatLabelValueIfPositive}
            />
          </Bar>
          <Bar dataKey="Holiday/Sick/ACC/KS" stackId="b" fill={COLORS.CHART_HOLIDAY} radius={CHART_CONFIG.ZERO_RADIUS} />
          <Bar dataKey="Supervisor" stackId="b" fill={COLORS.CHART_SUPERVISOR} radius={CHART_CONFIG.ZERO_RADIUS} />
          <Bar dataKey="Non-Productive" stackId="b" fill={COLORS.CHART_NON_PRODUCTIVE} radius={CHART_CONFIG.ZERO_RADIUS} />
          <Bar dataKey="Non-Essential" stackId="b" fill={COLORS.CHART_NON_ESSENTIAL} radius={CHART_CONFIG.ZERO_RADIUS} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
